<template>
  <div class="flex flex-col gap-4 py-4">
    <OrganizationTeamList />
  </div>
</template>
<script setup lang="ts">
  import { onMounted } from 'vue'
  import { useRouter } from 'vue-router'
  import { useApplicationModule } from '@/core/composables/use-application-module'
  import { ApplicationModule } from '@/core/models/organization'
  import OrganizationTeamList from '../components/OrganizationTeamList.vue'

  const router = useRouter()
  const { hasModule } = useApplicationModule()

  onMounted(() => {
    if (!hasModule(ApplicationModule.LUMIA)) {
      router.replace({ name: 'settings-organization-general' })
    }
  })
</script>
